import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, fmtINR } from "@/components/shared/Primitives";
import { supabase } from "@/lib/supabase";
export const Route = createFileRoute("/admin")({ component: Dashboard });
function Dashboard() {
  const [s, setS] = useState<any>({});
  useEffect(() => {
    Promise.all([
      supabase
        .from("products")
        .select("id", { count: "exact", head: true })
        .eq("status", "active"),
      supabase
        .from("profiles")
        .select("id", { count: "exact", head: true })
        .eq("role", "customer"),
      supabase.from("orders").select("total,payment_status"),
      supabase.from("service_tickets").select("status"),
    ]).then(([p, c, o, t]) =>
      setS({
        products: p.count || 0,
        customers: c.count || 0,
        orders: o.data?.length || 0,
        revenue: (o.data || [])
          .filter((x) => x.payment_status === "paid")
          .reduce((a, x) => a + Number(x.total || 0), 0),
        tickets: (t.data || []).filter(
          (x) => !["completed", "closed", "cancelled"].includes(x.status),
        ).length,
      }),
    );
  }, []);
  return (
    <div className="space-y-6">
      <PageHeader
        title="Dashboard"
        description="Live KIZAK commerce and service operations."
      />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5">
        {[
          ["Products", s.products, "/admin/products"],
          ["Customers", s.customers, "/admin/customers"],
          ["Orders", s.orders, "/admin/orders"],
          ["Revenue", fmtINR(s.revenue), "/admin/finance"],
          ["Open tickets", s.tickets, "/admin/tickets"],
        ].map(([l, v, to]) => (
          <Link
            to={to}
            key={l}
            className="rounded-2xl border border-border bg-card p-5 hover:border-primary"
          >
            <span className="text-xs text-muted-foreground">{l}</span>
            <b className="mt-2 block text-2xl">{v ?? "—"}</b>
          </Link>
        ))}
      </div>
    </div>
  );
}